import {
  Component,
  computed,
  effect,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

import { IconComponent } from '@shared/lib/components';
import {
  CloudService,
  DerivedAuthService,
  SalesforceService,
  SpinnerService,
} from '@shared/lib/services';
import { ISaleforceProgram } from '@shared/public-api';
import { environment } from 'projects/portal/src/environments/environment';

import { LeftNavigationService } from '../../services/left-navigation.service';
import { QualtricksComponent } from '../qualtricks/qualtricks.component';

@Component({
  selector: 'wu-left-navigation',
  imports: [RouterLink, RouterLinkActive, IconComponent, QualtricksComponent],
  templateUrl: './left-navigation.component.html',

  styleUrl: './left-navigation.component.scss',
})
export class LeftNavigationComponent implements OnInit {
  private readonly cloudService = inject(CloudService);
  private readonly spinnerService = inject(SpinnerService);
  private readonly authService = inject(DerivedAuthService);
  private readonly salesForceService = inject(SalesforceService);
  private readonly leftNavigationService = inject(LeftNavigationService);
  private readonly router = inject(Router);

  readonly routes = this.leftNavigationService.menus;
  readonly salesforceProgram = signal<ISaleforceProgram | null>(null);
  readonly userInfo = this.authService.userStudentInfo;
  readonly currentUser = this.authService.currentUser;
  readonly sourceId = this.authService.sourcedId;

  readonly programId = computed(
    () => this.authService.userProgram()?.parentSourcedId,
  );

  readonly degreeStatus = computed(
    () => this.authService.userInformation()?.info.degree_status,
  );

  readonly hasDegree = computed(() => !!this.degreeStatus);

  readonly e = effect(async () => {
    if (!this.sourceId()) {
      await this.leftNavigationService.fetchNavMenu();
      return;
    }
    this.initSaleforceDetails();
  });

  initSaleforceDetails() {
    this.spinnerService.show();
    this.salesForceService
      .getSalesForceProgramDetails(
        this.authService.userProgram()?.sourcedId!,
        environment.unifiedPortalGraphQlUrl,
      )
      .subscribe({
        next: async sfProgram => {
          await this.leftNavigationService.fetchNavMenu();
          this.spinnerService.hide();
        },
        error: async err => {
          await this.leftNavigationService.fetchNavMenu();
          console.error('Error fetching saleforce details', err);
          this.spinnerService.hide();
        },
      });
  }

  ngOnInit(): void {}

  onNavClick(routeUrl: string): void {
    const currentUrl = this.router.url.split('?')[0].split('#')[0];
    if (currentUrl === routeUrl) {
      this.leftNavigationService.sameRouteClick$.next(routeUrl);
    }
  }

  auditLog(
    logType: any,
    email: any,
    userId: any,
    userType: any,
    eventName: any,
    activityStatus: any,
    operationalStatus: any,
    payLoad: any,
    comments: any,
    eventType: any,
  ) {
    const auditData = {
      logType: logType,
      email: email,
      userId: userId,
      bannerId: this.userInfo()?.user?.info?.sourcedId?.split('.')[1],
      userType: userType,
      eventName: eventName,
      activityStatus: activityStatus,
      operationalStatus: operationalStatus,
      payLoad: payLoad,
      comments: comments,
      createdBy: 'Portal Refresh',
      eventType: eventType,
    };
    const baseUrlDetails = environment.cloudFunction.baseUrl;
    this.cloudService.postDataToBigQuery(
      baseUrlDetails,
      auditData,
      (response: any) => {
        // Handle success response
      },
      (error: any) => {
        console.error(error);
      },
    );
  }

  /* adding event to stack */
  addtoStack(id: any, action: any, logType: any, description: any) {
    const messageBody = description;
    const stackData = {
      email: id,
      activity: action,
      logType: logType,
      description: messageBody,
    };
    const baseUrlDetails = environment.cloudFunction.baseUrl;
    this.cloudService.postDataToStack(
      baseUrlDetails,
      stackData,
      response => {
        // Response callback
      },
      error => {
        console.error(error);
      },
    );
  }
}
